/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import path from 'js/lib/path';

import { Grid, Typography } from '@coursera/cds-core';

import DomainTopSkillPill from 'bundles/browse/components/Domain/DomainTopSkillPill';
import type { KnowsAbout, Locale } from 'bundles/shared-articles/components/ArticleAuthorProfile';
import { DEFAULT_COUNTRY_CODE } from 'bundles/unified-seo-content-common/constants';

import _t from 'i18n!nls/articles';

type Props = {
  isMobileScreen: boolean;
  items: KnowsAbout[];
};

function toCountrySubfolder(locale: Locale): string {
  return (locale.country === DEFAULT_COUNTRY_CODE ? '' : `/${locale.country}`).toLowerCase();
}

function toArticleCategoryUrl(item: KnowsAbout) {
  return path.join(toCountrySubfolder(item.locale), '/articles/category', item.slug);
}

const AuthorKnowsAbout = (props: Props) => {
  const { isMobileScreen, items } = props;
  return (
    <Grid item xs={12}>
      <Grid container spacing={isMobileScreen ? 8 : 16}>
        <Grid item xs={12}>
          <Typography variant="h2semibold">{_t('Knows About')}</Typography>
        </Grid>
        {items.map((item) => (
          <Grid item xs="auto">
            <DomainTopSkillPill
              skillId={item.slug}
              skillName={item.title}
              skillSearchUrl={toArticleCategoryUrl(item)}
            />
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};

export default AuthorKnowsAbout;
